import React from "react";
import { Navbar, Container } from "react-bootstrap";
import "../css/HelpHeader.css";

const HelpHeader = () => {
  return (
    <Navbar
      sticky="top"
      bg="light"
      variant="light"
      onToggle={() => {}}
      onSelect={() => {}}
      style={{ minHeight: "4em" }}
    >
      <Container>
        <img src="../mck-logo.png" alt="mck-logo" width="110" />
      </Container>
    </Navbar>
  );
};

export default HelpHeader;
